import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { CampaniaDctoMontos } from '../_models/campania-dcto-montos';
import { CampaniaDctoCiclos } from '../_models/campania-dcto-ciclos';

@Injectable({
  providedIn: 'root'
})
export class CampaniaDctoMontoservice {

  private rutaServicio = AppSettings.rutServiciosAPL + '/api/campaniaDctoMontos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoCampaniasDctoMontos() {
    return this.httClient.get( this.rutaServicio ).pipe( map( res => res as CampaniaDctoMontos[] ) );
  }

  listadoCampaniasDctoMontosHabilitadas() {
    return this.httClient.get( this.rutaServicio + '/enabled' ).pipe( map( res => res as CampaniaDctoMontos[] ) );
  }
  listadoCampaniasDctoMontosIdCampania(id: string) {
    return this.httClient.get( this.rutaServicio + '/campania/' + id + '/findAll' ).pipe( map( res => res as CampaniaDctoMontos[] ) );
  }

  listadoCampaniasDctoMontosHabilitadasIdCampania(id: string) {
    return this.httClient.get( this.rutaServicio + '/campania/' + id ).pipe( map( res => res as CampaniaDctoMontos[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutaServicio + '/' + id ).pipe( map( res => res as CampaniaDctoMontos ) );
  }

  crear( campaniaDctoMontos: CampaniaDctoMontos ) {
    campaniaDctoMontos.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutaServicio, campaniaDctoMontos ).pipe( map( res => res as CampaniaDctoMontos ) );
  }

  actualizar( campaniaDctoMontos: CampaniaDctoMontos ) {
    campaniaDctoMontos.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutaServicio, campaniaDctoMontos ).pipe( map( res => res as any ) );
  }


}
